import React, {useEffect, useState} from 'react';
import axios from "../../../helpers/axios";
import {Link} from "react-router-dom";
import {RacoonGroupCreateRoute, RacoonGroupEditRoute} from "../../routesConstants";
import Tooltip from "../../../helpers/ToolTip";
import moment from "moment";
import numberFormat from "../../../helpers/numberFormat";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Form, Tab, Tabs} from "react-bootstrap";
import SearchSelect from "../../../components/searchSelect";
import {GROUP_RACOON_TYPE} from "./GroupForm";
import BlockUi from "@availity/block-ui";
import {Table} from "reactstrap";
import GroupTable from "./groupTable";
import sayError from "../../../helpers/sayError";

const GroupList = () => {
  const [tabIndex, setTabIndex] = useState("actual");
  const [query, setQuery] = useState({
    name:'',
    counterparty:null,
    typeRacoon: null
  });
  const [counterparties, setCounterparties] = useState()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState()
  const loadList = () =>{
    setLoading(true)
    axios.post('/api/racoon/revise/group', {query})
      .then(({data})=>{
        console.log("list", data.items)
        setData(data.items)
      })
      .finally(()=>setLoading(false))
  }

  useEffect(() => {
    axios.post('/api/counterparty/searchInput', )
      .then(({data})=>{
        setCounterparties(data.data)
      })
  }, []);

  useEffect(() => {
    loadList()
  }, [query]);

  const changeType = (id, typeRacoon) => {
    setLoading(true)
    axios.patch(`/api/racoon/revise/group/${id}/type`, {typeRacoon})
      .then(() => loadList())
      .catch((err) => {
        sayError(err)
        setLoading(false)
      })
  }



  return (
    <Portlet>
      <PortletHeader
        title={"Список групп реестров"}
        toolbar={
          <PortletHeaderToolbar>
            <div className={'d-flex gap-2'}>
              {counterparties && <>
                <div style={{position: 'relative', width: 200}}>
                  <label className={'absolutLabel'}>Имя</label>
                  <Form.Control
                    defaultValue={query.name}
                    onChange={(e) => setQuery(q => ({...q, name: e.target.value}))}
                    className={'form-control'}
                    type={'text'}
                    placeholder="Поиск..."
                  />
                </div>
                <div style={{width: '14rem'}}>
                  <SearchSelect
                    onChange={v => {
                      setQuery(q => ({...q, counterparty: v}))
                    }}
                    defaultValue={query.counterparty}
                    label={'Контрагент'}
                    unregister
                    array={[{value: null, label: 'Все'}, ...counterparties]}/>
                </div>
                <div style={{width: '14rem'}}>
                  <SearchSelect
                    onChange={v => {
                      setQuery(q => ({...q, typeRacoon: v}))
                    }}
                    defaultValue={query.typeRacoon}
                    label={'Тип'}
                    unregister
                    array={[{value: null, label: 'Все'}, ...GROUP_RACOON_TYPE.map(t => ({label: t, value: t}))]}/>
                </div>
              </>
              }
              <Link to={RacoonGroupCreateRoute} className="btn btn-sm btn-primary d-flex align-items-center">
                <i className="la la-plus"/>
                <div>Добавить</div>
              </Link>
            </div>

          </PortletHeaderToolbar>
        }
      />
      <BlockUi blocking={loading}>
          {/*<DataTable columns={columns} search={query} url={`/api/racoon/revise/group`}/>*/}
          {data && <Tabs
            id="controlled-tab-example"
            activeKey={tabIndex}
            onSelect={key => {
              setTabIndex(key)
            }}
          >
            <Tab eventKey="actual" title="Актуальные" >
              <GroupTable array={data.actual} onChangeType={changeType}/>
            </Tab>
            <Tab eventKey="old" title="Устаревшие">
              <GroupTable array={data.archive}/>

            </Tab>
          </Tabs>}
      </BlockUi>
    </Portlet>
  );
};

export default GroupList;
